import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const COLUMNS = 'columns'

export default {
  [PORTUGUESE]: {
    [COLUMNS]: 'COLUNAS',
  },

  [ENGLISH]: {
    [COLUMNS]: 'COLUMNS',
  },

  [SPANISH]: {
    [COLUMNS]: 'COLUMNAS',
  },
}
